import { motion } from "framer-motion";
import { DiffCard } from "../DiffCard";
import { SpecimenLabel } from "../SpecimenLabel";

export const FrameProof1 = () => {
  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="max-w-6xl mx-auto">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <SpecimenLabel text="THE EXTRACTION" className="mb-4 block" />
          <h2 className="font-editorial text-3xl md:text-4xl text-foreground">
            See the transformation
          </h2>
        </motion.div>

        <DiffCard
          before="We worked with this company and they did a good job. The team was professional and delivered on time. Would recommend."
          after="🚀 Unpopular opinion: Your testimonials are sitting on a goldmine.

Most companies collect praise, file it away, and forget it exists.

We just worked with a client who called us 'professional' and said we 'delivered on time.'

That single sentence became:
→ 3 LinkedIn posts
→ A case study intro  
→ 5 carousel slides

Stop hoarding praise. Start deploying it."
          beforeLabel="RAW FEEDBACK"
          afterLabel="LINKEDIN POST"
        />
      </div>
    </section>
  );
};
